/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { errorResponseSchema } from "../errorResponseSchema.ts";
import { messageResponseSchema } from "../messageResponseSchema.ts";
import { z } from "zod";

export const cancelInvitationToOrganizationPathParamsSchema = z.object({
      "id": z.string().describe("ID unique de l'organisation.")
      })

export const cancelInvitationToOrganizationQueryParamsSchema = z.object({
      "email": z.string().describe("Email de l'utilisateur dont l'invitation doit être annulée.")
      })

export const cancelInvitationToOrganizationHeaderParamsSchema = z.object({
      "X-Client-Id": z.string().describe("ID du client/application pour lequel récupérer les informations utilisateur.")
      })

/**
 * @description Réponse contenant un message simple
 */
export const cancelInvitationToOrganization200Schema = z.lazy(() => messageResponseSchema).describe("Réponse contenant un message simple")

/**
 * @description Réponse d\'erreur standard
 */
export const cancelInvitationToOrganization500Schema = z.lazy(() => errorResponseSchema).describe("Réponse d'erreur avec message et code de statut")

export const cancelInvitationToOrganizationMutationResponseSchema = z.lazy(() => cancelInvitationToOrganization200Schema)